import styled from "@emotion/styled";
import {
    KmsTypeFilterItemGroup,
    isKmsTypeFilterItemRadio,
    isKmsTypeFilterItemCheckbox,
    SupportedKmsTypeFilterItem,
} from "@kaltura/mediaspace-shared-types";
import { FilterItem } from "./FilterItem";
import { CheckboxFilterItem } from "./CheckboxFilterItem";
import { RadioFilterItem } from "./RadioFilterItem";
import FormControl from "@mui/material/FormControl";
import { FilterItemAdditionalProps } from "./FilterItemAdditionalProps";

export type GroupFilterItemProps = KmsTypeFilterItemGroup & FilterItemAdditionalProps;

const StyledGroupFilterItem = styled(FormControl)(({ theme }) => ({
    marginBottom: theme.spacing(2),
}));

/**
 * group filter item - a radio/checkbox item holding other items as a group
 *
 * the value of such item is always an empty string "", to differentiate it from the
 * no selection option.
 */
export function GroupFilterItem(props: GroupFilterItemProps) {
    const { items, values, onChange, ...itemProps } = props;

    const getItemValue = <T extends SupportedKmsTypeFilterItem>(item: T): T["value"] => {
        if (!values || !values[item.param!]) {
            return undefined;
        }
        if (Array.isArray(values[item.param!])) {
            return values[item.param!][0];
        }
        return values[item.param!] as string;
    };

    return (
        <StyledGroupFilterItem>
            {isKmsTypeFilterItemCheckbox(itemProps) && (
                <CheckboxFilterItem {...itemProps} value="" onChange={onChange}></CheckboxFilterItem>
            )}

            {isKmsTypeFilterItemRadio(itemProps) && (
                <RadioFilterItem {...itemProps} value="" onChange={onChange}></RadioFilterItem>
            )}

            {itemProps.checked
                && !itemProps.disabled
                && items.map(<T extends SupportedKmsTypeFilterItem>(item: T, index: number) => {
                    item = {
                        ...item,
                        value: getItemValue(item),
                    };
                    return <FilterItem key={index} {...item} param={item.param!} onChange={onChange} />;
                })}
        </StyledGroupFilterItem>
    );
}

export default GroupFilterItem;
